@if (!hidden()) {
  @let showWarning =
    !!warning() &&
    warningVisible() &&
    !hasError() &&
    !isInvalid() &&
    !disabled();

  <div class="input">
    @if (label(); as label) {
      <onyx-input-label
        [disabled]="disabled()"
        [required]="required() && showRequired()"
        [label]="label"
        [hint]="hint()"
        [link]="link()"
        [alignRight]="alignLabelRight()"
        (click)="focus()"
      ></onyx-input-label>
    }

    <div
      class="container {{ `size-${size()}` }}"
      [class.disabled]="disabled()"
      [class.invalid]="isInvalid()"
      [class.warning]="showWarning"
      [onyxTooltip]="warning()"
      [onyxTooltipDisabled]="!showWarning || showErrors()"
      [class.active]="value_()"
      tabindex="-1"
      (click)="focus()"
      (keydown)="(undefined)"
    >
      <input
        [type]="computedType()"
        [disabled]="disabled()"
        [attr.autocomplete]="autocomplete()"
        [attr.placeholder]="placeholder() ?? '' | translate"
        (keypress)="validateInput($event)"
        (paste)="validatePaste($event)"
        (input)="handleValueChange($event)"
        (focusin)="focused.set(true)"
        (focusout)="
          trimValue();
          touch.emit();
          focused.set(false);
          warningVisible.set(true)
        "
        #inputElement
      />

      <div class="options">
        <div class="actions">
          @if (value_() && !disabled()) {
            <ng-content select="[action]"></ng-content>

            @if (showClear()) {
              <onyx-clear-button
                data-testid="clear-button"
                (click)="clearInput()"
              ></onyx-clear-button>
            }
          }
        </div>

        <ng-content select="[option]"></ng-content>

        @if (showPassword() != null) {
          <onyx-icon-button
            variant="transparent"
            color="gray"
            [size]="20"
            [tabindex]="-1"
            [disabled]="disabled()"
            (click)="toggleShowPassword()"
          >
            <onyx-icon
              class="f-muted"
              [name]="
                showPassword()
                  ? 'visibility-hidden-outlined'
                  : 'visibility-shown-outlined'
              "
              [size]="20"
            ></onyx-icon>
          </onyx-icon-button>
        }

        @if (unit(); as unit) {
          <p class="hint">{{ unit | translate }}</p>
        }

        @if (maxLengthHint()) {
          <p class="hint">{{ maxLengthHint() }}</p>
        }
      </div>

      @if (!disabled()) {
        <ng-content></ng-content>
      }
    </div>
  </div>

  @let control = formField() ?? formControl();
  @if (control && showErrors()) {
    <onyx-error
      [errors]="[control]"
      variant="control"
      (hasErrorChange)="hasError.set($event)"
    ></onyx-error>
  }

  @if (showWarning && showErrors() && warning(); as warning) {
    <p class="warning-message f-body-xs f-medium">
      <onyx-icon name="alert-circle-two-tone-filled" [size]="12"></onyx-icon>
      {{ warning | translate }}
    </p>
  }
}
